import React from 'react';
import { Box, Text } from 'rebass/styled-components';

export const AgentTitle = () => (
  <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
    <Text
      sx={{
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '24px',
      }}
    >
      Sourcing AI Agent{' '}
    </Text>
    <Text
      sx={{
        background: 'linear-gradient(94deg, #4900FF 3.21%, #D400FF 63.82%, #FF9257 134.26%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textAlign: 'center',
        fontSize: '10px',
        fontStyle: 'italic',
        fontWeight: '600',
        lineHeight: '16px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        mb: '4px',
      }}
    >
      BETA
    </Text>
  </Box>
);
